import {
  StyleSheet,
} from "react-native";
import { fonts } from "../../../styles/theme";
const PropertyMapsMobileStyle = StyleSheet.create({
  container: {
    flex: 1,
  },
  map: {
    width: "100%",
    height: "100%",
  },
  table: {
    width: "100%",
    marginBottom: 20,
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  linkContainer:{
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  icon:{
    height: 30, width: 30 
  },
  tableLabel: {
    fontWeight: "bold",
    fontSize: 16,
    flex: 1,
    fontFamily: fonts.regular,
  },
  tableValue: {
    fontSize: 16,
    flex: 2,
    textAlign: "right",
    fontWeight:'bold',
    fontFamily: fonts.regular,
  },
  modalContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContent: {
    width: "80%",
    backgroundColor: "white",
    padding: 20,
    borderRadius: 10,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 10,
    fontFamily: fonts.regular,
  },
});


export default PropertyMapsMobileStyle;